export default __webpack_public_path__ + "static/media/ladies.dfd9f66b.png";